import { Routes, Route, useLocation } from 'react-router-dom';
// Components
import Navbar from './components/navbar/Navbar.jsx';
//Auth
import Login from './pages/auth/Login.jsx';
import Register from './pages/auth/Register.jsx';
import ForgotPassword from './pages/auth/ForgotPassword.jsx';
import RestPassword from './pages/auth/ResetPassword.jsx';
// Pages
import Home from './pages/Home.jsx';
// Linkroots
import Linkroot from './pages/admin/Linkroot.jsx';
import LinkrootUser from './pages/admin/user/LinkrootUser.jsx';
import LinkrootCompany from './pages/admin/company/LinkrootCompany.jsx';
import LinkrootPricing from './pages/admin/pricingConfig/LinkrootPricing.jsx';
import LinkrootDescription from './pages/admin/unitsLevels/LinkrootDescription.jsx';
import LinkrootServer from './pages/admin/server/LinkrootServer.jsx';
// Rol Admin
import AssignAdmins from './pages/admin/user/AssignAdmins.jsx';
import CreateUser from './pages/admin/user/CreateUser.jsx';
import ListUser from './pages/admin/user/ListUser.jsx';
import EditUser from './pages/admin/user/EditUser.jsx';
import CreateCompany from './pages/admin/company/CreateCompany.jsx';
import ListCompany from './pages/admin/company/ListCompany.jsx';
import EditCompany from './pages/admin/company/EditCompany.jsx';
// Rol Usuario
import Calculator from './pages/user/Calculator.jsx';
import Descriptions from './pages/user/Descriptions.jsx';
// Precios
import EditHoursMatrix from './pages/admin/pricingConfig/EditHoursMatrix.jsx';
import ListPricing from './pages/admin/pricingConfig/ListPricing.jsx';
import EditPricingHours from './pages/admin/pricingConfig/EditPricingHours.jsx';
// Medidas de extencion
import ListExtensionUnits from './pages/admin/unitsLevels/extensionUnits/ListExtensionUnits.jsx';
import EditExtensionUnit from './pages/admin/unitsLevels/extensionUnits/EditExtensionUnit.jsx';
// Nivel instruccional
import ListInstructionalLevels from './pages/admin/unitsLevels/instructionalLevels/ListInstructionalLevels.jsx';
import EditInstructionalLevel from './pages/admin/unitsLevels/instructionalLevels/EditInstructionalLevel.jsx';
// Nivel multimedia
import ListMultimediaLevels from './pages/admin/unitsLevels/multimediaLevels/ListMultimediaLevels.jsx';
import EditMultimediaLevel from './pages/admin/unitsLevels/multimediaLevels/EditMultimediaLevel.jsx';
// Server
import ListLogs from './pages/admin/server/ListLogs.jsx';
// Otras
import HelloWorld from './pages/others/HelloWorld.jsx';
import Error404 from './pages/others/Error404.jsx';
import Unauthorized from './pages/others/Unauthorized.jsx';
import Systeminfo from './pages/others/Systeminfo.jsx';
// Servicios
import ROUTES from './routes/Routes.js';
import ProtectedRoute from './routes/ProtectedRoute.js';

function App() {
    // Hook useLocation para obtener la ruta actual
    const location = useLocation();

    // Rutas sin el Navbar
    const hideNavbarRoutes = [ROUTES.HELLOWORLD, ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.FORGOT_PASSWORD, ROUTES.RESET_PASSWORD];

    return (
        <div className="App">
            {/* Renderiza el Navbar solo si la ruta actual no está en hideNavbarRoutes */}
            {!hideNavbarRoutes.includes(location.pathname) && <Navbar />} 

            <Routes>
                {/* Rutas publicas */}
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.LOGIN} element={<Login />} />
                <Route path={ROUTES.REGISTER} element={ <Register /> } />
                <Route path={ROUTES.FORGOT_PASSWORD} element={ <ForgotPassword /> } />
                <Route path={ROUTES.RESET_PASSWORD} element={ <RestPassword /> } />

                {/* Rutas protegidas */}    
                {/* Linkroots */}   
                <Route path={ROUTES.LINKROOT} element={<ProtectedRoute component={Linkroot} requiredRole="1" />} />   
                <Route path={ROUTES.LINKROOTUSER} element={<ProtectedRoute component={LinkrootUser} requiredRole="1" />} />
                <Route path={ROUTES.LINKROOTCOMPANY} element={<ProtectedRoute component={LinkrootCompany} requiredRole="1" />} />
                <Route path={ROUTES.LINKROOTPRICING} element={<ProtectedRoute component={LinkrootPricing} requiredRole="1" />} />
                <Route path={ROUTES.LINKROOT_DESCRIPTION} element={<ProtectedRoute component={LinkrootDescription} requiredRole="1" />} />
                <Route path={ROUTES.LINKROOT_SERVER} element={<ProtectedRoute component={LinkrootServer} requiredRole="1" />} />
                
                {/* Admins */}                
                <Route path={ROUTES.ADMINS} element={<ProtectedRoute component={AssignAdmins} requiredRole="1" />} />
                <Route path={ROUTES.CREATEUSER} element={<ProtectedRoute component={CreateUser} requiredRole="1" />} />
                <Route path={ROUTES.LISTUSER} element={<ProtectedRoute component={ListUser} requiredRole="1" />} />
                <Route path={`${ROUTES.EDITUSER}/:id`} element={<ProtectedRoute component={EditUser} requiredRole="1" />} />
                <Route path={ROUTES.CREATE_COMPANY} element={<ProtectedRoute component={CreateCompany} requiredRole="1" />} />
                <Route path={ROUTES.LIST_COMPANY} element={<ProtectedRoute component={ListCompany} requiredRole="1" />} />
                <Route path={`${ROUTES.EDIT_COMPANY}/:id`} element={<ProtectedRoute component={EditCompany} requiredRole="1" />} />
                {/*Usuarios*/}
                <Route path={ROUTES.CALCULATOR} element={<ProtectedRoute component={Calculator} />} />
                <Route path={ROUTES.DESCRIPTIONS} element={<ProtectedRoute component={Descriptions} />} />
                {/*Precios*/}
                <Route path={ROUTES.EDIT_HOURS_MATRIX} element={<ProtectedRoute component={EditHoursMatrix} requiredRole="1" />} />
                <Route path={ROUTES.LIST_PRICING_HOURS} element={<ProtectedRoute component={ListPricing} requiredRole="1" />} />
                <Route path={`${ROUTES.EDIT_PRICING_HOURS}/:id`} element={<ProtectedRoute component={EditPricingHours} requiredRole="1" />} />
                {/*Medidas de extencion*/}
                <Route path={ROUTES.LIST_EXTENSION_UNITS} element={<ProtectedRoute component={ListExtensionUnits} requiredRole="1" />} />
                <Route path={`${ROUTES.EDIT_EXTENSION_UNITS}/:id`} element={<ProtectedRoute component={EditExtensionUnit} requiredRole="1" />} />
                {/*Nivel instruccional*/}
                <Route path={ROUTES.LIST_INSTRUCTIONAL_LEVELS} element={<ProtectedRoute component={ListInstructionalLevels} requiredRole="1" />} />
                <Route path={`${ROUTES.EDIT_INSTRUCTIONAL_LEVELS}/:id`} element={<ProtectedRoute component={EditInstructionalLevel} requiredRole="1" />} />
                {/*Nivel multimedia*/}
                <Route path={ROUTES.LIST_MULTIMEDIA_LEVELS} element={<ProtectedRoute component={ListMultimediaLevels} requiredRole="1" />} />
                <Route path={`${ROUTES.EDIT_MULTIMEDIA_LEVELS}/:id`} element={<ProtectedRoute component={EditMultimediaLevel} requiredRole="1" />} />
                {/*Server*/}
                <Route path={ROUTES.LOGS_VIEWER} element={<ProtectedRoute component={ListLogs} requiredRole="1" />} />
                
                {/* Otras */}
                <Route path={ROUTES.UNAUTHORIZED} element={<ProtectedRoute component={Unauthorized} />} />
                <Route path={ROUTES.HELLOWORLD} element={<HelloWorld />}/>
                <Route path={ROUTES.SYSTEMINFO} element={<ProtectedRoute component={Systeminfo} requiredRole="1" />} />
                <Route path="*" element={<Error404 />}/>
            </Routes>
        </div>
    );
}

export default App;